<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="consulting"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign4.png"> 我的{{tabName}}列表</span></h2>
              <div style="width: 100%;" v-if="consulting_list && consulting_list.length>0">
              <el-card class="box-card" shadow="hover"
                       style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                       v-for="(item,index) in consulting_list" :key="index"
              >
                <div slot="header" class="clearfix">
                  <span>
                       <el-tag v-if="item.esStatus!='3'"
                               type="danger"
                               effect="dark" style="width: 55px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    待处理
                  </el-tag>
                       <el-tag  v-if="item.esStatus=='3'"

                                effect="dark" style="width: 55px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    已回复
                  </el-tag>
                    <span style="font-weight: 600">{{item.sTitle}}</span>
                      </span>
                </div>
                <div class="text item" style="line-height: 23px;" >
                  <div style="display: flex;justify-content: left;">
                    <div style="width:300px;"><span class="yy_title">{{tabName}}类别：</span><span class="yy_title_content">{{item.sChildCatagory}}</span></div>
                    <div><span class="yy_title">{{tabName}}日期：</span><span class="yy_title_content">{{item.sTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title">{{tabName}}内容：</span><span class="yy_title_content">{{item.sReamrk}}</span></div>
                  </div>
                  <el-divider content-position="left" v-if="item.esStatus=='3'">办理回复</el-divider>
                  <div style="display: flex;justify-content: left;"  v-if="item.esStatus=='3'">
                    <div style="width:300px;"><span class="yy_title">受理单位：</span><span class="yy_title_content">{{item.departId}}</span></div>
                    <div><span class="yy_title">回复时间：</span><span class="yy_title_content">{{item.esOverTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;" v-if="item.esStatus=='3'">
                    <div><span class="yy_title">回复内容：</span><span class="yy_title_content">{{item.esRemark}}</span></div>
                  </div>
                </div>
              </el-card>
              </div>
              <div v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <!--<table width="96%" border="0" cellspacing="0" cellpadding="0" class="personal_tab">-->
              <!--<tr class="personal_tit">-->
              <!--<td width="11%">咨询类别</td>-->
              <!--<td width="11%">咨询标题</td>-->
              <!--<td width="22%">咨询内容</td>-->
              <!--<td width="13%">咨询日期</td>-->
              <!--<td width="12%">受理单位</td>-->
              <!--<td width="12%">回复内容</td>-->
              <!--<td width="11%">回复时间</td>-->
              <!--&lt;!&ndash;                  <td width="8%">操作</td>&ndash;&gt;-->
              <!--</tr>-->
              <!--<tr v-for="(item,index) in consulting_list" :key="index">-->
              <!--<td>{{item.sChildCatagory}}</td>-->
              <!--<td>{{item.sTitle}}</td>-->
              <!--<td>{{item.sReamrk}}</td>-->
              <!--<td>{{item.sTime}}</td>-->
              <!--<td>{{item.partyName}}</td>-->
              <!--<td>{{item.esRemark}}</td>-->
              <!--<td>{{item.esOverTime}}</td>-->
              <!--&lt;!&ndash;                  <td class="per_button1"><a href="javascript:void(0)"><img src="../../../static/images/personal_sign1.png"> 详情</a> <br/><a&ndash;&gt;-->
              <!--&lt;!&ndash;                    href="javascript:void(0)"><img src="../../../static/images/personal_sign2.png"> 删除</a></td>&ndash;&gt;-->
              <!--</tr>-->
              <!--</table>-->
              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
import personal from "../../components/Personal";
export default {
  name: "Consulting",
  components: {
    headers, fixedDiv, footers,personal
  },
  data(){
    return{
      consulting_list:[],
      loginShow:false,
      gotoIndex:false,
      tabName:'',
      typeId:0,
    }
  },
  created(){
    this.typeId=this.$route.query.type;
    if(!this.typeId){
      this.typeId=1
    }
    if(this.typeId==1){
      this.tabName="投诉"
    }else if(this.typeId==2){
      this.tabName="建议"
    }else if(this.typeId==3){
      this.tabName="表扬"
    }else if(this.typeId==4){
      this.tabName="咨询"
    }

  },
  mounted() {
    var userInfo=this.$cookies.get('userInfo')
    if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
      this.loginShow=true;
      this.gotoIndex=true;
    }
    this.getListData()
  },
  methods:{
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    } ,
    getListData() {
      this.$https.post("/api/suggest/getSuggest.do", {typeId:this.typeId}, response => {
        if (response.status === 200 && response.data.code === 200) {
          if (!this.$util.isEmpty(response.data.data)) {
            this.consulting_list = response.data.data;
          }
        }
      });
    }
  }
}
</script>

<style>
  .personal_right .el-card__header {
    padding: 9px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/Consulting.vue